/**
 * Barre de progression à deux paliers (livraison offerte + cadeau au choix).
 * Source de vérité : /cart.js. Tous les blocs [data-gift-progress] (desktop et mobile) sont mis à jour ensemble.
 * Éligibilité cadeau : somme des original_line_price hors lignes cadeau (TTC avant code promo).
 */
(function () {
  'use strict';

  var STORE_KEY = 'gp_removed_gift';
  var SEEN_KEY = 'gp_seen_gift';
  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var busy = false;
  var rerun = false;

  function isGift(item) {
    return !!item.properties && item.properties._gift === 'true';
  }

  function roots() {
    return document.querySelectorAll('[data-gift-progress]');
  }

  function readConfig(root) {
    return {
      ship: parseInt(root.dataset.ship, 10),
      gift: parseInt(root.dataset.gift, 10),
      shipEnabled: root.dataset.shipEnabled !== 'false',
      giftEnabled: root.dataset.giftEnabled !== 'false'
    };
  }

  function money(root, cents, trim) {
    var value = cents / 100;
    var options = { style: 'currency', currency: root.dataset.currency };
    if (trim && Number.isInteger(value)) {
      options.minimumFractionDigits = 0;
      options.maximumFractionDigits = 0;
    }
    try {
      return new Intl.NumberFormat(root.dataset.locale || undefined, options).format(value);
    } catch (e) {
      return value.toFixed(2) + ' ' + root.dataset.currency;
    }
  }

  function compute(cart, config, shipExcluded) {
    var gifts = cart.items.filter(isGift);
    var eligible = cart.items.reduce(function (sum, item) {
      return isGift(item) ? sum : sum + item.original_line_price;
    }, 0);
    // Le prix éventuel du cadeau ne compte ni dans le seuil cadeau ni dans le seuil livraison.
    var total = cart.items.reduce(function (sum, item) {
      return isGift(item) ? sum : sum + (item.final_line_price !== undefined ? item.final_line_price : item.original_line_price);
    }, 0);
    total = Math.min(total, cart.total_price);
    var giftEnabled = config.giftEnabled !== false;
    var shipEnabled = config.shipEnabled !== false;
    var giftEligible = giftEnabled && eligible >= config.gift;
    // Le palier livraison reste validé dès que le cadeau est débloqué.
    var shipDone = !shipEnabled || shipExcluded || giftEligible || total >= config.ship;
    var state;
    if (!shipDone) state = 'ship';
    else if (!giftEnabled) state = 'shipdone';
    else if (!giftEligible) state = 'gift';
    else state = gifts.length ? 'added' : 'unlocked';
    return {
      eligible: eligible,
      total: total,
      gifts: gifts,
      giftEligible: giftEligible,
      shipDone: shipDone,
      state: state
    };
  }

  function setMessage(root, template, cents, split) {
    var el = root.querySelector('[data-gp-message]');
    el.textContent = '';
    var amount = cents === null ? null : money(root, cents);
    var idx = template.indexOf('[amount]');
    var head = idx > 0 ? template.slice(0, idx).replace(/[\s\u00b7]+$/, '') : '';
    var separated = !!split && amount !== null && head !== '';
    el.classList.toggle('is-split', separated);
    if (separated) {
      [head, template.slice(head.length, idx), template.slice(idx)].forEach(function (text, i) {
        if (!text) return;
        var span = document.createElement('span');
        if (i === 1) span.className = 'gift-progress__sep';
        el.appendChild(span);
        if (i === 2) {
          var bold = document.createElement('strong');
          span.appendChild(bold);
          fillMessage(bold, text, amount);
          return;
        }
        fillMessage(span, text, amount);
      });
      return;
    }
    fillMessage(el, template, amount);
  }

  function fillMessage(el, template, amount) {
    // **texte** = gras ; [amount] = montant en gras.
    template.split('**').forEach(function (chunk, i) {
      var host = el;
      if (i % 2) {
        host = document.createElement('strong');
        el.appendChild(host);
      }
      var parts = chunk.split('[amount]');
      parts.forEach(function (part, j) {
        if (j > 0 && amount !== null) {
          var strong = document.createElement('strong');
          strong.textContent = amount;
          host.appendChild(strong);
        }
        if (part) host.appendChild(document.createTextNode(part));
      });
    });
  }

  function feedback(root, text) {
    var el = root.querySelector('[data-gp-feedback]');
    if (!el) return;
    el.textContent = text || '';
    el.hidden = !text;
  }

  function getStored(key) {
    try {
      return JSON.parse(sessionStorage.getItem(key || STORE_KEY));
    } catch (e) {
      return null;
    }
  }

  function setStored(value, key) {
    try {
      if (value) sessionStorage.setItem(key || STORE_KEY, JSON.stringify(value));
      else sessionStorage.removeItem(key || STORE_KEY);
    } catch (e) { /* stockage indisponible */ }
  }

  // Dernier cadeau vu dans le panier : permet de proposer "Reprendre" même si le retrait n'a pas passé par enforce().
  function trackGift(s, config) {
    var stored = getStored();
    if (s.gifts.length) {
      setStored({ id: s.gifts[0].variant_id, handle: s.gifts[0].handle }, SEEN_KEY);
      if (stored) setStored(null);
      return null;
    }
    if (s.giftEligible || !config.giftEnabled) {
      setStored(null, SEEN_KEY);
      return stored && s.giftEligible ? stored : null;
    }
    var seen = getStored(SEEN_KEY);
    if (!stored && seen) {
      setStored(seen);
      setStored(null, SEEN_KEY);
      stored = seen;
    }
    return stored;
  }

  var unlock = null;

  function priceCents(product, kind) {
    var swatch = product.querySelector('.product-preview-swatches-color.selected');
    if (swatch) {
      var raw = kind === 'gift' ? swatch.dataset.compare || swatch.dataset.price : swatch.dataset.price;
      var n = parseInt(raw, 10);
      if (!isNaN(n)) return n;
    }
    var matches = (product.querySelector('.gbp-price') || {}).textContent;
    matches = matches && matches.match(/\d+[.,]\d+/g);
    return matches ? Math.round(parseFloat(matches[matches.length - 1].replace(',', '.')) * 100) : 0;
  }

  // Message rouge sur les produits "Vous aimerez aussi" qui suffisent à débloquer le prochain palier.
  function applyUnlockTags() {
    document.querySelectorAll('.group-buy-product').forEach(function (product) {
      var link = product.querySelector('.gbp-infos a');
      if (!link) return;
      var el = link.querySelector('.gbp-unlock');
      var text = '';
      if (unlock && priceCents(product, unlock.kind) >= unlock.remaining) {
        text = unlock.kind === 'ship' ? unlock.root.dataset.msgUnlockShip : unlock.root.dataset.msgUnlockGift;
      }
      if (!text) {
        if (el) el.remove();
        return;
      }
      if (!el) {
        el = document.createElement('span');
        el.className = 'gbp-tag gbp-unlock';
        link.insertBefore(el, link.firstChild);
      }
      if (el.textContent !== text) el.textContent = text;
    });
  }

  var tagFrame = 0;
  new MutationObserver(function () {
    if (tagFrame) return;
    tagFrame = requestAnimationFrame(function () {
      tagFrame = 0;
      applyUnlockTags();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  function render(cart) {
    unlock = null;
    roots().forEach(function (root) {
      var config = readConfig(root);
      var s = compute(cart, config, root.dataset.shipExcluded === 'true');
      var stored = trackGift(s, config);

      root.dataset.state = s.state;
      root.dataset.shipDone = String(s.shipDone);
      root.dataset.unlocked = String(s.giftEligible);

      var shipVisible = config.shipEnabled && root.dataset.shipExcluded !== 'true';
      // Rien à afficher : livraison seule mais non applicable au panier.
      root.hidden = !config.giftEnabled && !shipVisible;

      if (s.state === 'ship') setMessage(root, root.dataset.msgShip, Math.max(config.ship - s.total, 0), true);
      else if (s.state === 'shipdone') setMessage(root, root.dataset.msgShipDone, null);
      else if (s.state === 'gift') {
        setMessage(root, shipVisible ? root.dataset.msgGift : root.dataset.msgGiftOnly, Math.max(config.gift - s.eligible, 0));
      }
      else if (s.state === 'unlocked') setMessage(root, root.dataset.msgUnlocked, null);
      else setMessage(root, root.dataset.msgAdded, null);

      if (!unlock) {
        if (s.state === 'ship') unlock = { kind: 'ship', remaining: config.ship - s.total, root: root };
        else if (s.state === 'gift') unlock = { kind: 'gift', remaining: config.gift - s.eligible, root: root };
      }

      var shipPct = Math.min(Math.max((config.ship / config.gift) * 100, 8), 92);
      // Remplissage par paliers : 0 -> livraison jusqu'au camion, livraison -> cadeau jusqu'au cadeau.
      var fillPct;
      if (!config.giftEnabled) {
        fillPct = Math.min(s.total / config.ship, 1) * 100;
      } else if (!shipVisible) {
        fillPct = Math.min(s.eligible / config.gift, 1) * 100;
      } else if (s.total < config.ship && !s.giftEligible) {
        fillPct = (s.total / config.ship) * shipPct;
      } else {
        var span = Math.max(config.gift - config.ship, 1);
        fillPct = shipPct + (Math.min(Math.max(s.eligible - config.ship, 0) / span, 1)) * (100 - shipPct);
      }
      root.querySelector('[data-gp-fill]').style.width = Math.min(Math.max(fillPct, 0), 100) + '%';
      root.querySelector('[data-gp-ship-node]').style.left = config.giftEnabled ? shipPct + '%' : '100%';
      root.querySelector('[data-gp-ship-label]').style.left = config.giftEnabled ? shipPct + '%' : '';
      root.querySelector('[data-gp-ship-amount]').textContent = money(root, config.ship);
      root.querySelector('[data-gp-gift-amount]').textContent = money(root, config.gift);

      root.querySelectorAll('[data-gp-tpl]').forEach(function (el) {
        el.textContent = el.dataset.gpTpl.replace('[amount]', money(root, config.gift, true));
      });

      var selectedId = s.gifts.length ? String(s.gifts[0].variant_id) : null;
      root.querySelectorAll('[data-gp-card]').forEach(function (card) {
        var cardSelected = false;
        card.querySelectorAll('[data-gp-variant]').forEach(function (btn) {
          if (!btn.dataset.label) btn.dataset.label = btn.textContent.trim();
          var isSelected = btn.dataset.variantId === selectedId;
          btn.classList.toggle('is-selected', isSelected);
          btn.disabled = s.gifts.length > 0;
          if (isSelected) cardSelected = true;
          // Variante unique : le libellé devient "Ajouté".
          var single = card.querySelectorAll('[data-gp-variant]').length === 1;
          btn.textContent = single && isSelected ? root.dataset.msgAdded : btn.dataset.label;
        });
        var select = card.querySelector('[data-gp-select]');
        if (select) {
          var hasOption = !!selectedId && !!select.querySelector('option[value="' + selectedId + '"]');
          if (hasOption) select.value = selectedId;
          select.disabled = s.gifts.length > 0;
          if (hasOption) cardSelected = true;
          var addBtn = card.querySelector('[data-gp-add]');
          if (addBtn) {
            if (!addBtn.dataset.label) addBtn.dataset.label = addBtn.textContent.trim();
            addBtn.disabled = s.gifts.length > 0;
            addBtn.classList.toggle('is-selected', hasOption);
            addBtn.textContent = hasOption ? root.dataset.msgAdded : addBtn.dataset.label;
          }
        }
        card.classList.toggle('is-selected', cardSelected);
      });

      var resume = root.querySelector('[data-gp-resume]');
      if (resume) {
        resume.hidden = !(stored && !s.gifts.length);
        resume.querySelector('[data-gp-resume-btn]').disabled = false;
      }
    });
    applyUnlockTags();
  }

  function fetchCart() {
    return fetch('/cart.js?t=' + Date.now(), { cache: 'no-store', headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  // Retire les cadeaux sous le seuil, et force une seule ligne en quantité 1.
  function enforce(cart, root) {
    var s = compute(cart, readConfig(root), root.dataset.shipExcluded === 'true');
    if (!s.gifts.length) return Promise.resolve(false);

    var updates = {};
    var dirty = false;
    if (!s.giftEligible) {
      s.gifts.forEach(function (g) { updates[g.key] = 0; });
      if (readConfig(root).giftEnabled) setStored({ id: s.gifts[0].variant_id, handle: s.gifts[0].handle });
      dirty = true;
    } else {
      s.gifts.forEach(function (g, i) {
        var qty = i === 0 ? 1 : 0;
        if (g.quantity !== qty) {
          updates[g.key] = qty;
          dirty = true;
        }
      });
    }
    if (!dirty) return Promise.resolve(false);

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: JSON_HEADERS,
      body: JSON.stringify({ updates: updates })
    }).then(function (r) { return r.ok; });
  }

  function refreshDrawer(root) {
    if (typeof window.refreshSideCartItems === 'function') {
      window.refreshSideCartItems(root ? root.closest('.js-menu__context') : document.querySelector('.js-menu__context'));
    } else {
      refresh();
    }
  }

  function refresh() {
    var list = roots();
    if (!list.length) return Promise.resolve();
    if (busy) {
      rerun = true;
      return Promise.resolve();
    }
    busy = true;
    if (typeof window.freeShippingCheckTags === 'function') window.freeShippingCheckTags();

    var changed = false;
    return fetchCart()
      .then(function (cart) {
        return enforce(cart, list[0]).then(function (didChange) {
          changed = didChange;
          return didChange ? fetchCart() : cart;
        });
      })
      .then(render)
      .catch(function () { /* l'état précédent est conservé */ })
      .then(function () {
        busy = false;
        if (changed) refreshDrawer(list[0]);
        else if (rerun) {
          rerun = false;
          refresh();
        }
      });
  }

  function productUrl(handle) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'products/' + encodeURIComponent(handle) + '.js';
  }

  function hideVariant(root, variantId) {
    var btn = root.querySelector('[data-gp-variant][data-variant-id="' + variantId + '"], [data-gp-select] option[value="' + variantId + '"]');
    if (btn) btn.remove();
  }

  function addGift(root, variantId, handle) {
    if (busy) return Promise.resolve();
    busy = true;
    root.classList.add('is-busy');
    feedback(root, '');
    var added = false;

    return fetch(productUrl(handle), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (product) {
        var variant = product.variants.filter(function (v) { return v.id === variantId; })[0];
        if (!variant || !variant.available) {
          hideVariant(root, variantId);
          setStoredIfSame(variantId);
          feedback(root, root.dataset.msgUnavailable);
          return null;
        }
        return fetchCart().then(function (cart) {
          var s = compute(cart, readConfig(root), root.dataset.shipExcluded === 'true');
          if (!s.giftEligible || s.gifts.length) return null;
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: JSON_HEADERS,
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { _gift: 'true' } }] })
          }).then(function (res) {
            if (res.ok) {
              added = true;
              setStored(null);
            } else if (res.status === 422) {
              hideVariant(root, variantId);
              setStoredIfSame(variantId);
              feedback(root, root.dataset.msgUnavailable);
            } else {
              feedback(root, root.dataset.msgError);
            }
          });
        });
      })
      .catch(function () { feedback(root, root.dataset.msgError); })
      .then(function () {
        busy = false;
        root.classList.remove('is-busy');
        if (added) refreshDrawer(root);
        else refresh();
      });
  }

  function setStoredIfSame(variantId) {
    var stored = getStored();
    if (stored && stored.id === variantId) setStored(null);
  }

  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-gp-add]');
    if (addBtn) {
      var addCard = addBtn.closest('[data-gp-card]');
      var sel = addCard.querySelector('[data-gp-select]');
      if (!addBtn.disabled && sel && sel.value) {
        addGift(addBtn.closest('[data-gift-progress]'), parseInt(sel.value, 10), addCard.dataset.handle);
      }
      return;
    }
    var variantBtn = e.target.closest('[data-gp-variant]');
    if (variantBtn) {
      var root = variantBtn.closest('[data-gift-progress]');
      var card = variantBtn.closest('[data-gp-card]');
      if (!variantBtn.disabled) addGift(root, parseInt(variantBtn.dataset.variantId, 10), card.dataset.handle);
      return;
    }
    var resumeBtn = e.target.closest('[data-gp-resume-btn]');
    if (resumeBtn && !resumeBtn.disabled) {
      var resumeRoot = resumeBtn.closest('[data-gift-progress]');
      var stored = getStored();
      if (!stored) return;
      busy || fetchCart().then(function (cart) {
        var s = compute(cart, readConfig(resumeRoot), resumeRoot.dataset.shipExcluded === 'true');
        if (s.giftEligible) {
          addGift(resumeRoot, stored.id, stored.handle);
        } else {
          var missing = Math.max(readConfig(resumeRoot).gift - s.eligible, 0);
          feedback(resumeRoot, resumeRoot.dataset.msgGiftOnly.replace('[amount]', money(resumeRoot, missing)));
        }
      });
    }
  });

  window.GiftProgress = { refresh: refresh, compute: compute };
  document.addEventListener('DOMContentLoaded', refresh);
})();
